import { Pipe, PipeTransform } from '@angular/core';
import { FormatTimePipe } from './formatTime';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }


    transform(value: string, displayTime = false, format = 2): any {
        if (!value) {
            return '';
        }
        const date = new Date(value);
        let time = '';
        if (displayTime) {
            time = ' ' + FormatTimePipe.format(date, this.translate);
        }
        const month = format === 2 ?
            date.toLocaleString('en-US', {month: 'short'}) : date.getMonth() + 1;
        return `${date.getFullYear()}/${month}/${date.getDate()}` + time;
    }
}
